'use strict';

require('../../style/index.css');

require('./index.css');

require('../../button/style/css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/modal/style/css.js
// module id = zqh5
// module chunks = 0